const _ = require("lodash");
const dayjs = require("dayjs");
const { city } = require("../../env.js");
const 區碼 = {
  臺南市: {
    新營區: "0501",
    鹽水區: "0502",
    白河區: "0503",
    麻豆區: "0504",
    佳里區: "0505",
    新化區: "0506",
    善化區: "0507",
    學甲區: "0508",
    柳營區: "0509",
    後壁區: "0510",
    東山區: "0511",
    下營區: "0512",
    六甲區: "0513",
    官田區: "0514",
    大內區: "0515",
    西港區: "0516",
    七股區: "0517",
    將軍區: "0518",
    北門區: "0519",
    新市區: "0520",
    安定區: "0521",
    山上區: "0522",
    玉井區: "0523",
    楠西區: "0524",
    南化區: "0525",
    左鎮區: "0526",
    仁德區: "0527",
    歸仁區: "0528",
    關廟區: "0529",
    龍崎區: "0530",
    永康區: "0531",
    東區: "0532",
    南區: "0533",
    中西區: "0534",
    北區: "0535",
    安南區: "0537",
    安平區: "0538",
  },
  高雄市: {
    鳳山區1: "0701",
    岡山區: "0702",
    旗山區: "0703",
    美濃區: "0704",
    林園區: "0705",
    大寮區: "0706",
    大樹區: "0707",
    仁武區: "0708",
    大社區: "0709",
    鳥松區: "0710",
    橋頭區: "0711",
    燕巢區: "0712",
    田寮區: "0713",
    阿蓮區: "0714",
    路竹區: "0715",
    湖內區: "0716",
    茄萣區: "0717",
    永安區: "0718",
    彌陀區: "0719",
    梓官區: "0720",
    六龜區: "0721",
    甲仙區: "0722",
    杉林區: "0723",
    內門區: "0724",
    茂林區: "0725",
    桃源區: "0726",
    那瑪夏區: "0727",
    鹽埕區: "0728",
    鼓山區: "0729",
    左營區: "0730",
    楠梓區: "0731",
    三民區1: "0732",
    新興區: "0733",
    前金區: "0734",
    苓雅區: "0735",
    前鎮區: "0736",
    旗津區: "0737",
    小港區: "0738",
    三民區2: "0739",
    鳳山區2: "0740",
  },
};

function normalizePrintPayload(person, section) {
  const safePerson = person || {};
  safePerson.問卷 = safePerson.問卷 || {};
  safePerson.目前狀態 = safePerson.目前狀態 || {};
  safePerson.篩檢項目 = safePerson.篩檢項目 || {};
  safePerson.report = Array.isArray(safePerson.report) ? safePerson.report : [{}];
  safePerson.report[0] = safePerson.report[0] || {};
  return {
    person: safePerson,
    section: section || {},
  };
}

module.exports.複檢單 = (person, section) => {
  ({ person, section } = normalizePrintPayload(person, section));
  let r = person.血液報告;
  return {
    bg: "複檢單.jpg",
    items: [
      {
        condition: true,
        text:
          person.report[0].id93 + " - " + _.padStart(person.報到號碼, 4, "0"),
        right: 12,
        top: 6,
        style: ["font18", "bold"],
      },
      {
        condition: true,
        text: section.行政區 + " " + (section.口腔初檢醫療院所代碼 || ""),
        left: 53,
        top: 30,
        style: ["font18", "bold"],
      },
      {
        condition: true,
        text: person.姓名,
        left: 42,
        top: 64,
      },
      {
        condition: true,
        text: person.身分證字號,
        left: 147,
        top: 54,
        width: 47.8,
        height: 10,
        pl: 4,
        pt: 5,
        style: ["bg"],
      },
      {
        condition: true,
        text: person.出生年月日,
        left: 146,
        top: 64.1,
        width: 44,
        style: ["bg"],
      },
      {
        condition: person.report[0].血液檢查.性別 == "男",
        text: "█",
        left: 93,
        top: 64.5,
        style: ["font14"],
      },
      {
        condition: person.report[0].血液檢查.性別 == "女",
        text: "█",
        left: 106,
        top: 64.5,
        style: ["font14"],
      },
      {
        condition: true,
        text: person.電話,
        left: 34.3,
        top: 69,
        width: 44,
      },
      {
        condition: true,
        text: person.地址,
        left: 32,
        top: 74.3,
        width: 150,
        pl: 1.6,
        style: ["bg"],
      },
      {
        condition: r.血壓.high,
        text: "█",
        left: 25.5,
        top: 90,
        style: ["font14"],
      },
      {
        condition: r.血壓.abnormal.length,
        text:
          (person.report[0].第一次收縮壓 || "-") +
          "/" +
          (person.report[0].第一次舒張壓 || "-") +
          ", " +
          (person.report[0].第二次收縮壓 || "-") +
          "/" +
          (person.report[0].第二次舒張壓 || "-"),
        left: 90,
        top: 89,
      },
      {
        condition: r.血糖.high,
        text: "█",
        left: 25.5,
        top: 95,
        style: ["font14"],
      },
      {
        condition: r.血糖.abnormal.length,
        text: r.raw.GLU,
        left: 83,
        top: 94.5,
      },
      {
        condition: r.血脂.high,
        text: "█",
        left: 25.5,
        top: 100,
        style: ["font14"],
      },
      {
        condition: r.血脂.abnormal.length,
        text: r.raw.CHOL,
        left: 78,
        top: 99.7,
      },
      {
        condition: r.血脂.abnormal.length,
        text: r.raw.TG,
        left: 143,
        top: 99.7,
      },
      {
        condition: r.肝.abnormal.length,
        text: "█",
        left: 25.5,
        top: 110.3,
        style: ["font14"],
      },
      {
        condition: r.肝.abnormal.length,
        text: r.raw.SGOT,
        left: 64.6,
        top: 109.8,
      },
      {
        condition: r.肝.abnormal.length,
        text: r.raw.SGPT,
        left: 84,
        top: 109.8,
      },
      {
        condition: _.find(r.肝.abnormal, (o) => o.item == "HBsAg"),
        text: "█",
        left: 129.2,
        top: 110.3,
        style: ["font14"],
      },
      {
        condition: _.find(r.肝.abnormal, (o) => o.item == "HCV"),
        text: "█",
        left: 156.6,
        top: 110.3,
        style: ["font14"],
      },
      {
        condition: r.腎.abnormal.length,
        text: "█",
        left: 25.5,
        top: 115.4,
        style: ["font14"],
      },
      {
        condition: r.腎.abnormal.length,
        text: r.raw.BUN,
        left: 64,
        top: 115,
      },
      {
        condition: r.腎.abnormal.length,
        text: r.raw.CREA,
        left: 82,
        top: 115,
      },
      {
        condition: r.腎.abnormal.length,
        text: r.raw.蛋白質,
        left: 108.8,
        top: 114,
      },
      {
        condition: r.腎.abnormal.length,
        text: r.raw.潛血,
        left: 145.3,
        top: 114,
      },
      {
        condition: r.腎.abnormal.length,
        text: r.raw.eGFR,
        left: 69,
        top: 121,
        style: ["font12"],
      },
      {
        condition: r.腎.abnormal.length,
        text: r.raw.腎臟病期別,
        left: 118.5,
        top: 120,
        style: ["font13"],
      },
      {
        condition: true,
        text: "&nbsp;",
        right: 20,
        top: 39,
        width: 50,
        style: ["bg"],
      },
    ],
  };
};

module.exports.轉診單 = (person, section, type) => {
  ({ person, section } = normalizePrintPayload(person, section));
  let r = person.血液報告;
  let typeItems = [];
  switch (type) {
    case "三高":
      let text = [];
      if (r.血壓.abnormal.length) {
        text.push(
          r.血壓.abnormal.map((o) => `${o.item}:${o.value}`).join(", ")
        );
      }
      if (r.血糖.abnormal.length) {
        text.push(
          r.血糖.abnormal.map((o) => `${o.item}:${o.value}`).join(", ")
        );
      }
      if (r.血脂.abnormal.length) {
        text.push(
          r.血脂.abnormal.map((o) => `${o.item}:${o.value}`).join(", ")
        );
      }
      typeItems = [
        {
          condition: true,
          text: section.日期 + " 血壓、血糖、血脂異常",
          left: 30,
          top: 65,
        },
        {
          condition: true,
          text: text.join("<br>"),
          left: 30,
          top: 70,
          style: ["font15"],
        },
      ];
      break;
    case "肝":
      typeItems = [
        {
          condition: true,
          text: section.日期 + " 肝功能異常",
          left: 30,
          top: 65,
        },
        {
          condition: true,
          text: r.肝.abnormal.map((o) => `${o.item}:${o.value}`).join(", "),
          left: 30,
          top: 72,
        },
      ];
      break;
    case "腎":
      typeItems = [
        {
          condition: true,
          text: section.日期 + " 腎臟指數異常",
          left: 30,
          top: 65,
        },
        {
          condition: true,
          text: r.腎.abnormal.map((o) => `${o.item}:${o.value}`).join(", "),
          left: 30,
          top: 72,
        },
      ];
      break;
  }

  return {
    bg: "轉診單.jpg",
    items: [
      ...typeItems,

      {
        condition: true,
        text:
          person.report[0].id93 + " - " + _.padStart(person.報到號碼, 4, "0"),
        right: 12,
        top: 4,
        style: ["font18", "bold"],
      },
      {
        condition: true,
        text: section.行政區 + "衛生所",
        left: 62,
        top: 12.5,
        width: 39.5,
        style: ["font20", "bold", "bg"],
      },
      {
        condition: true,
        text: section.口腔初檢醫療院所代碼,
        left: 67,
        top: 23.3,
      },
      {
        condition: true,
        text: person.姓名,
        left: 44,
        top: 37.5,
      },
      {
        condition: true,
        text: person.出生年月日,
        left: 107,
        top: 37.2,
        width: 30,
        style: ["font15", "bg"],
      },
      {
        condition: true,
        text: person.身分證字號,
        left: 154,
        top: 37.2,
        width: 30,
        style: ["font15", "bg"],
      },
      {
        condition: true,
        text: person.姓名,
        left: 30.5,
        top: 51.7,
      },
      {
        condition: true,
        text: person.電話,
        left: 53,
        top: 51.7,
      },
      {
        condition: true,
        text: person.地址,
        left: 88,
        top: 51.7,
      },
    ],
  };
};
module.exports.腸篩 = (person, section) => {
  ({ person, section } = normalizePrintPayload(person, section));
  return {
    bg: "腸篩.jpg",
    items: [
      {
        condition: section.糞便潛血支付方式 == "預防保健",
        text: "V",
        left: 44,
        top: 28,
      },
      {
        condition: section.糞便潛血支付方式 == "健保醫療給付",
        text: "V",
        left: 71,
        top: 28,
      },
      {
        condition: section.糞便潛血支付方式 == "其他公務預算補助",
        text: "V",
        left: 105.5,
        top: 28,
      },
      {
        condition: section.糞便潛血支付方式 == "自費健康檢查",
        text: "V",
        left: 148,
        top: 28,
      },
      {
        condition: section.糞便潛血支付方式 == "其他",
        text: "V",
        left: 44,
        top: 33,
      },
      {
        condition: section.糞便潛血篩選地點 == "社區或職場設站篩檢",
        text: "V",
        left: 44.4,
        top: 38.3,
      },
      {
        condition: section.糞便潛血篩選地點 == "門診",
        text: "V",
        left: 91,
        top: 38.3,
      },
      {
        condition: section.糞便潛血篩選地點 == "住院",
        text: "V",
        left: 109.8,
        top: 38.3,
      },
      {
        condition: section.糞便潛血篩選地點 == "郵寄",
        text: "V",
        left: 132.3,
        top: 38.3,
      },
      {
        condition: section.糞便潛血篩選地點 == "其他",
        text: "V",
        left: 148,
        top: 38.3,
      },
      {
        condition: true,
        text: person.姓名,
        left: 40,
        top: 51,
      },
      {
        condition: 性別(person) == "男",
        text: "V",
        left: 103.5,
        top: 51.5,
      },
      {
        condition: 性別(person) == "女",
        text: "V",
        left: 115,
        top: 51.5,
      },
      {
        condition: true,
        text: person.出生年月日,
        left: 151,
        top: 51.5,
        width: 44,
        style: ["bg"],
        textAlign: "left",
      },
      {
        condition: true,
        text: person.身分證字號,
        left: 50,
        top: 61,
        width: 50,
        pl: 4,
        style: ["bg"],
      },
      {
        condition: true,
        text: person.電話,
        left: 147,
        top: 63.3,
      },
      {
        condition: true,
        text: person.地址,
        left: 37,
        top: 75.5,
        width: 150,
        height: 9,
        pt: 1,
        style: ["bg"],
      },
      {
        condition: person.問卷.教育程度 == "無",
        text: "V",
        left: 29.3,
        top: 85.2,
      },
      {
        condition: person.問卷.教育程度 == "小學",
        text: "V",
        left: 44.3,
        top: 85.2,
      },
      {
        condition: person.問卷.教育程度 == "國(初)中",
        text: "V",
        left: 63.6,
        top: 85.2,
      },
      {
        condition: person.問卷.教育程度 == "高中/高職",
        text: "V",
        left: 94,
        top: 85.2,
      },
      {
        condition: person.問卷.教育程度 == "專科、大學",
        text: "V",
        left: 123,
        top: 85.2,
      },
      {
        condition: person.問卷.教育程度 == "研究所以上",
        text: "V",
        left: 153.5,
        top: 85.2,
      },
      {
        condition: person.問卷.教育程度 == "拒答",
        text: "V",
        left: 184,
        top: 85.2,
      },
      {
        condition: person.問卷.家族遺傳性非瘜肉大腸直腸癌,
        text: "V",
        left: 166.5,
        top: 104,
      },
      {
        condition: !person.問卷.家族遺傳性非瘜肉大腸直腸癌,
        text: "V",
        left: 151.5,
        top: 104,
      },
      {
        condition:
          person.問卷["家族血癌（白血病）"] ||
          person.問卷["家族骨癌"] ||
          person.問卷["家族鼻咽癌"] ||
          person.問卷["家族口腔癌"] ||
          person.問卷["家族食道癌"] ||
          person.問卷["家族子宮頸癌"] ||
          person.問卷["家族乳癌"] ||
          person.問卷["家族肝癌"] ||
          person.問卷["家族肺癌"] ||
          person.問卷["家族胃癌"] ||
          person.問卷["家族胰臟癌"] ||
          person.問卷["家族膽囊癌"] ||
          person.問卷["家族卵巢癌"] ||
          person.問卷["家族攝護腺癌"] ||
          person.問卷["家族其他癌症"],
        text: "V",
        left: 162.7,
        top: 110.5,
      },
      {
        condition: !(
          person.問卷["家族血癌（白血病）"] ||
          person.問卷["家族骨癌"] ||
          person.問卷["家族鼻咽癌"] ||
          person.問卷["家族口腔癌"] ||
          person.問卷["家族食道癌"] ||
          person.問卷["家族子宮頸癌"] ||
          person.問卷["家族乳癌"] ||
          person.問卷["家族肝癌"] ||
          person.問卷["家族肺癌"] ||
          person.問卷["家族胃癌"] ||
          person.問卷["家族胰臟癌"] ||
          person.問卷["家族膽囊癌"] ||
          person.問卷["家族卵巢癌"] ||
          person.問卷["家族攝護腺癌"] ||
          person.問卷["家族其他癌症"]
        ),
        text: "V",
        left: 147.7,
        top: 110.5,
      },
      {
        condition: person.問卷.腸胃自覺異狀,
        text: "V",
        left: 174.5,
        top: 128.6,
      },
      {
        condition: !person.問卷.腸胃自覺異狀,
        text: "V",
        left: 189.5,
        top: 128.6,
      },
      {
        condition: true,
        text: section.糞便潛血檢驗機構代碼,
        // text: "0000000000",
        left: 71,
        top: 157.9,
      },
      {
        condition: true,
        text: section.日期,
        left: 127,
        top: 157,
        width: 60,
        pl: 2,
        pt: 0.8,
        style: ["bg"],
        textAlign: "left",
      },
      {
        condition: true,
        text: 區碼[city.name][person.行政區] || "",
        left: 72,
        top: 69.5,
        width: 18,
        pl: 1,
        style: ["bg"],
      },
    ],
  };
};
module.exports.胃篩 = (person, section) => {
  ({ person, section } = normalizePrintPayload(person, section));
  return {
    bg: "胃篩.jpg",
    items: [
      {
        condition: section.胃篩支付方式 == "預防保健",
        text: "V",
        top: 23.9,
        left: 29.6,
      },
      {
        condition: section.胃篩支付方式 == "健保醫療給付",
        text: "V",
        top: 23.9,
        left: 49.2,
      },
      {
        condition: section.胃篩支付方式 == "其他公務預算補助",
        text: "V",
        top: 23.9,
        left: 76.2,
      },
      {
        condition: section.胃篩支付方式 == "自費健康檢查",
        text: "V",
        top: 23.9,
        left: 111.2,
      },
      {
        condition: section.胃篩支付方式 == "其他",
        text: "V",
        top: 23.9,
        left: 138.2,
      },
      {
        // 胃篩採檢單位
        condition: true,
        text: section.胃篩採檢單位 || "",
        top: 28.6,
        left: 37,
        style: ["font15"],
      },
      {
        // 胃篩醫事機構代碼
        condition: true,
        text: section.胃篩醫事機構代碼 || "",
        top: 28.6,
        left: 101,
        style: ["font15"],
      },
      {
        // 姓名
        condition: true,
        text: person.姓名,
        top: 34,
        left: 31,
        style: ["font15"],
      },
      {
        // 男
        condition: 性別(person) == "男",
        text: "V",
        top: 34.2,
        left: 71.2,
        style: ["font15"],
      },
      {
        // 女
        condition: 性別(person) == "女",
        text: "V",
        top: 34.2,
        left: 79.8,
        style: ["font15"],
      },
      {
        // 身分證字號
        condition: true,
        text: person.身分證字號,
        top: 39.8,
        left: 30.4,
        style: ["font15"],
      },
      {
        // 出生年月日
        condition: true,
        text: person.出生年月日,
        width: 37,
        top: 39.8,
        left: 91.4,
        style: ["bg"],
        textAlign: "left",
        pl: 4,
      },
      {
        // 民國年
        condition: true,
        text: section.日期.split("-")[0] - 1911,
        top: 39.8,
        left: 166,
        style: ["font14"],
      },
      {
        condition: true,
        text: section.日期.split("-")[1],
        top: 39.8,
        left: 180,
        style: ["font14"],
      },
      {
        condition: true,
        text: section.日期.split("-")[2],
        top: 39.8,
        left: 191,
        style: ["font14"],
      },
      {
        // 電話
        condition: true,
        text: person.電話,
        top: 51,
        left: 91.4,
        style: ["font15"],
      },
      {
        // 地址
        condition: true,
        text: person.地址,
        height: 12,
        width: 150,
        top: 67,
        left: 19.4,
        style: ["bg"],
        textAlign: "left",
        pl: 10,
        pt: 2,
      },
      {
        // 區碼
        condition: true,
        text: 區碼[city.name][person.行政區] || "",
        width: 17,
        top: 61.5,
        left: 63,
        style: ["font15", "bg"],
      },
      {
        // 教育 - 無
        condition: person.問卷.教育程度 == "無",
        text: "V",
        top: 77.6,
        left: 29.5,
      },
      {
        // 教育 - 小學
        condition: person.問卷.教育程度 == "小學",
        text: "V",
        top: 77.6,
        left: 39.2,
      },
      {
        // 教育 - 國(初)中
        condition: person.問卷.教育程度 == "國(初)中",
        text: "V",
        top: 77.6,
        left: 52.9,
      },
      {
        // 教育 - 高中/高職
        condition: person.問卷.教育程度 == "高中/高職",
        text: "V",
        top: 77.6,
        left: 72.9,
      },
      {
        // 教育 - 專科、大學
        condition: person.問卷.教育程度 == "專科、大學",
        text: "V",
        top: 77.6,
        left: 94.3,
      },
      {
        // 教育 - 研究所以上
        condition: person.問卷.教育程度 == "研究所以上",
        text: "V",
        top: 77.6,
        left: 119.6,
      },
      {
        // 教育 - 拒答
        condition: person.問卷.教育程度 == "拒答",
        text: "V",
        top: 77.6,
        left: 144.8,
      },
      {
        // person.問卷["家族胃癌"]
        condition: person.問卷["家族胃癌"],
        text: "V",
        top: 164,
        left: 63.5,
        style: ["font18"],
      },
    ],
  };
};

module.exports.胃篩檢驗結果 = () => ({
  bg: "胃篩_2.jpg",
  items: [],
});

module.exports.HPV = (person, section) => {
  ({ person, section } = normalizePrintPayload(person, section));
  return {
    bg: "HPV.jpg",
    items: [
      {
        // 本國
        condition: true,
        text: "⬤",
        top: 25,
        left: 32.5,
        style: ["font14"],
      },
      {
        // 否
        condition: section.HPV抹片車或社區巡迴服務 == "否",
        text: "⬤",
        top: 34,
        left: 21.5,
        style: ["font14"],
      },
      {
        // 抹片車
        condition: section.HPV抹片車或社區巡迴服務 == "抹片車",
        text: "⬤",
        top: 34,
        left: 30.6,
        style: ["font14"],
      },
      {
        // 社區巡迴服務
        condition: section.HPV抹片車或社區巡迴服務 == "社區巡迴服務",
        text: "⬤",
        top: 34,
        left: 47.6,
        style: ["font14"],
      },
      {
        // 預防保健
        condition: true,
        text: "⬤",
        top: 38.8,
        left: 42.5,
        style: ["font14"],
      },
      {
        // 姓名
        condition: true,
        text: person.姓名,
        top: 61,
        left: 51,
        style: ["font15"],
      },
      {
        // 出生年月日
        condition: true,
        text: person.出生年月日,
        top: 66.4,
        left: 50,
        width: 40,
        height: 4.7,
        pl: 4,
        style: ["bg", "font15"],
        textAlign: "left",
      },
      {
        // 身分證字號
        condition: true,
        text: person.身分證字號,
        height: 4.9,
        width: 72,
        top: 75.3,
        left: 25,
        pl: 22,
        style: ["bg", "font15"],
        textAlign: "left",
      },
      {
        // 電話
        condition: true,
        text: person.電話,
        top: 79.3,
        left: 57,
        style: ["font15"],
      },
      {
        // 教育 - 無
        condition: person.問卷.教育程度 == "無",
        text: "⬤",
        top: 84.4,
        left: 35.5,
        style: ["font14"],
      },
      {
        // 教育 - 小學
        condition: person.問卷.教育程度 == "小學",
        text: "⬤",
        top: 84.4,
        left: 44.5,
        style: ["font14"],
      },
      {
        // 教育 - 國(初)中
        condition: person.問卷.教育程度 == "國(初)中",
        text: "⬤",
        top: 84.4,
        left: 57.5,
        style: ["font14"],
      },
      {
        // 教育 - 高中/高職
        condition: person.問卷.教育程度 == "高中/高職",
        text: "⬤",
        top: 84.4,
        left: 76.5,
        style: ["font14"],
      },
      {
        // 教育 - 專科、大學
        condition: person.問卷.教育程度 == "專科、大學",
        text: "⬤",
        top: 88.9,
        left: 35.5,
        style: ["font14"],
      },
      {
        // 教育 - 研究所以上
        condition: person.問卷.教育程度 == "研究所以上",
        text: "⬤",
        top: 88.9,
        left: 59.5,
        style: ["font14"],
      },
      {
        // 教育 - 拒答
        condition: person.問卷.教育程度 == "拒答",
        text: "⬤",
        top: 88.9,
        left: 83.5,
        style: ["font14"],
      },
      {
        // 地址
        condition: true,
        text: person.地址,
        top: 99.3,
        left: 18,
        width: 81,
        height: 14,
        pt: 1,
        style: ["bg", "font15"],
        textAlign: "left",
      },
      {
        // 區碼
        condition: true,
        text: 區碼[city.name][person.行政區] || "",
        width: 20,
        top: 107.3,
        left: 77,
        style: ["font15"],
      },
      {
        // 城市
        condition: true,
        text: city.name,
        top: 120.3,
        left: 43,
        style: ["font14"],
      },
      {
        // 行政區
        condition: true,
        text: person.行政區.replace(city.name, "").replace("區", ""),
        top: 120.3,
        left: 59,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用口服避孕藥 === "是",
        text: "⬤",
        top: 175.7,
        left: 35.2,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用口服避孕藥 === "否",
        text: "⬤",
        top: 175.7,
        left: 26.2,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用賀爾蒙 === "是",
        text: "⬤",
        top: 185.5,
        left: 55,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用賀爾蒙 === "否",
        text: "⬤",
        top: 185.5,
        left: 45.6,
        style: ["font14"],
      },
      {
        // 民國年
        condition: true,
        text: section.日期.split("-")[0] - 1911,
        top: 35.5,
        left: 150,
        style: ["font12"],
      },
      {
        condition: true,
        text: section.日期.split("-")[1],
        top: 35.5,
        left: 164,
        style: ["font12"],
      },
      {
        condition: true,
        text: section.日期.split("-")[2],
        top: 35.5,
        left: 177,
        style: ["font12"],
      },
      {
        // HPV檢查醫事機構代碼
        condition: true,
        text: section.HPV檢查醫事機構代碼 || "",
        top: 30,
        left: 150,
        style: ["font15"],
      },
      {
        // HPV檢體取樣醫事人員身分別 - 婦產科醫師
        condition: section.HPV檢體取樣醫事人員身分別 == "婦產科醫師",
        text: "⬤",
        top: 55,
        left: 118.2,
        style: ["font15"],
      },
      {
        // HPV檢體取樣醫事人員身分別 - 家醫科醫師
        condition: section.HPV檢體取樣醫事人員身分別 == "家醫科醫師",
        text: "⬤",
        top: 55,
        left: 142.4,
        style: ["font15"],
      },
      {
        // HPV檢體取樣醫事人員身分別 - 助產士
        condition: section.HPV檢體取樣醫事人員身分別 == "助產士",
        text: "⬤",
        top: 60.3,
        left: 118.2,
        style: ["font15"],
      },
      {
        // HPV檢體取樣醫事人員身分別 - 公衛護士
        condition: section.HPV檢體取樣醫事人員身分別 == "公衛護士",
        text: "⬤",
        top: 60.3,
        left: 138.7,
        style: ["font15"],
      },
      {
        // HPV檢體取樣醫事人員身分別 - 衛生所醫師
        condition: section.HPV檢體取樣醫事人員身分別 == "衛生所醫師",
        text: "⬤",
        top: 65.8,
        left: 118.2,
        style: ["font15"],
      },
      {
        // HPV檢查目的
        condition: section.HPV檢查目的 == "篩檢",
        text: "⬤",
        top: 76.1,
        left: 149.2,
        style: ["font15"],
      },
      {
        // HPV檢查目的
        condition: section.HPV檢查目的 == "追蹤",
        text: "⬤",
        top: 76.1,
        left: 162.2,
        style: ["font15"],
      },
      {
        // HPV檢查目的
        condition: section.HPV檢查目的 == "其他",
        text: "⬤",
        top: 76.1,
        left: 175.2,
        style: ["font15"],
      },
      {
        // 檢驗實驗室代碼
        condition: true,
        text: section.HPV檢驗實驗室代碼 || "12345667",
        top: 88,
        left: 150,
        style: ["font15"],
      },
    ],
  };
};
module.exports.乳攝 = (person, section) => {
  ({ person, section } = normalizePrintPayload(person, section));
  return {
    bg: "乳攝.jpg",
    items: [
      {
        condition: section.乳攝支付方式 == "預防保健",
        text: "V",
        left: 38.2,
        top: 27.9,
      },
      {
        condition: section.乳攝支付方式 == "健保醫療給付",
        text: "V",
        left: 59,
        top: 27.9,
      },
      {
        condition: section.乳攝支付方式 == "其他公務預算補助",
        text: "V",
        left: 87.4,
        top: 27.9,
      },
      {
        condition: section.乳攝支付方式 == "自費健康檢查",
        text: "V",
        left: 122.6,
        top: 27.9,
      },
      {
        condition: section.乳攝支付方式 == "其他",
        text: "V",
        left: 150.8,
        top: 27.9,
      },
      {
        condition: section.乳房攝影車篩檢 == "是",
        text: "V",
        left: 20,
        top: 42,
        style: ["font15"],
      },
      {
        condition: section.乳房攝影車篩檢 == "否",
        text: "V",
        left: 20,
        top: 37,
        style: ["font15"],
      },
      {
        condition: section.乳房攝影車篩檢 == "是",
        text: section.乳房攝影儀器登設字,
        left: 53,
        top: 41.5,
        style: ["font15"],
      },
      {
        condition: section.乳房攝影車篩檢 == "否",
        text: section.乳房攝影儀器登設字,
        left: 53,
        top: 37,
        style: ["font15"],
      },
      {
        condition: section.乳房攝影車篩檢 == "是",
        text: section.乳房攝影所屬單位院所名稱,
        left: 101,
        top: 41.5,
        style: ["font15"],
      },
      {
        condition: section.乳房攝影車篩檢 == "否",
        text: section.乳房攝影所屬單位院所名稱,
        left: 101,
        top: 37,
        style: ["font15"],
      },
      {
        condition: section.乳房攝影車篩檢 == "是",
        text: section.乳房攝影所屬單位院所代碼,
        left: 138,
        top: 41.5,
        style: ["font15"],
      },
      {
        condition: section.乳房攝影車篩檢 == "否",
        text: section.乳房攝影所屬單位院所代碼,
        left: 138,
        top: 37,
        style: ["font15"],
      },
      {
        condition: section.乳房攝影車篩檢 == "是",
        text: section.乳房攝影車號,
        left: 167,
        top: 41.5,
        style: ["font15"],
      },
      {
        condition: true,
        text: person.姓名,
        left: 60,
        top: 61,
      },
      {
        condition: true,
        text: person.出生年月日,
        left: 60,
        top: 69.5,
        width: 40,
        style: ["bg"],
      },
      {
        condition: true,
        text: person.地址,
        left: 60,
        top: 82,
        width: 120,
        height: 8,
        pt: 1,
        style: ["bg"],
      },
      {
        condition: true,
        text: 區碼[city.name][person.行政區] || "",
        left: 70,
        top: 77,
        width: 20,
        height: 4,
        pl: 2,
        style: ["bg"],
      },
      {
        condition: true,
        text: person.身分證字號,
        left: 146,
        top: 57,
        width: 50,
        height: 3.9,
        // style: ["bg"],
      },
      {
        condition: true,
        text: person.電話,
        left: 157,
        top: 70.7,
      },
      {
        condition: person.問卷.教育程度 == "無",
        text: "V",
        left: 49.5,
        top: 91.8,
        style: ["font12"],
      },
      {
        condition: person.問卷.教育程度 == "小學",
        text: "V",
        left: 59,
        top: 91.8,
        style: ["font12"],
      },
      {
        condition: person.問卷.教育程度 == "國(初)中",
        text: "V",
        left: 71.8,
        top: 91.8,
        style: ["font12"],
      },
      {
        condition: person.問卷.教育程度 == "高中/高職",
        text: "V",
        left: 94,
        top: 91.8,
        style: ["font12"],
      },
      {
        condition: person.問卷.教育程度 == "專科、大學",
        text: "V",
        left: 114,
        top: 91.8,
        style: ["font12"],
      },
      {
        condition: person.問卷.教育程度 == "研究所以上",
        text: "V",
        left: 136,
        top: 91.8,
        style: ["font12"],
      },
      {
        condition: person.問卷.教育程度 == "拒答",
        text: "V",
        left: 158.3,
        top: 91.8,
        style: ["font12"],
      },
      {
        condition: person.問卷.個人乳癌,
        text: "V",
        left: 106.4,
        top: 112,
        style: ["font14"],
      },
      {
        condition: person.問卷.個人其他癌症 || person.問卷.個人攝護腺癌,
        text: "V",
        left: 119.2,
        top: 112,
        style: ["font14"],
      },
      {
        condition: !(
          person.問卷.個人其他癌症 ||
          person.問卷.個人攝護腺癌 ||
          person.問卷.個人乳癌
        ),
        text: "V",
        left: 52.5,
        top: 116.4,
        style: ["font14"],
      },
      {
        condition:
          person.問卷["家人罹患乳癌-祖母"] ||
          person.問卷["家人罹患乳癌-外祖母"] ||
          person.問卷["家人罹患乳癌-母親"] ||
          person.問卷["家人罹患乳癌-女兒"] ||
          person.問卷["家人罹患乳癌-姊姊"] ||
          person.問卷["家人罹患乳癌-妹妹"],
        text: "V",
        left: 52.5,
        top: 128,
        style: ["font14"],
      },
      {
        condition: !(
          person.問卷["家人罹患乳癌-祖母"] ||
          person.問卷["家人罹患乳癌-外祖母"] ||
          person.問卷["家人罹患乳癌-母親"] ||
          person.問卷["家人罹患乳癌-女兒"] ||
          person.問卷["家人罹患乳癌-姊姊"] ||
          person.問卷["家人罹患乳癌-妹妹"]
        ),
        text: "V",
        left: 52.5,
        top: 150,
        style: ["font14"],
      },
      {
        condition:
          person.問卷["家人罹患乳癌-姊姊"] || person.問卷["家人罹患乳癌-妹妹"],
        text: [
          person.問卷["家人罹患乳癌年齡-姊姊"],
          person.問卷["家人罹患乳癌年齡-妹妹"],
        ]
          .join(",")
          .split(",")
          .filter((o) => o).length,
        left: 120,
        top: 143,
      },
      {
        condition: person.問卷["家人罹患乳癌-母親"],
        text: [person.問卷["家人罹患乳癌年齡-母親"]]
          .join(",")
          .split(",")
          .filter((o) => o).length,
        left: 101.5,
        top: 143,
      },
      {
        condition: person.問卷["家人罹患乳癌-女兒"],
        text: [person.問卷["家人罹患乳癌年齡-女兒"]]
          .join(",")
          .split(",")
          .filter((o) => o).length,
        left: 138,
        top: 143,
      },
      {
        condition: person.問卷["家人罹患乳癌-祖母"],
        text: [person.問卷["家人罹患乳癌年齡-祖母"]]
          .join(",")
          .split(",")
          .filter((o) => o).length,
        left: 157.8,
        top: 143,
      },
      {
        condition: person.問卷["家人罹患乳癌-外祖母"],
        text: [person.問卷["家人罹患乳癌年齡-外祖母"]]
          .join(",")
          .split(",")
          .filter((o) => o).length,
        left: 176.5,
        top: 143,
      },
      {
        condition: true,
        text: person.問卷.初經年齡,
        left: 68,
        top: 158.2,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否已經停經 === "是",
        text: "V",
        left: 68.4,
        top: 162.7,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否已經停經 === "否",
        text: "V",
        left: 70.4,
        top: 174.2,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否已經停經 === "是",
        text: person.問卷.停經年齡,
        left: 97,
        top: 162.7,
        style: ["font14"],
      },
      {
        condition: person.問卷.停經原因 == "自然停經",
        text: "V",
        left: 93.7,
        top: 177,
        style: ["font14"],
      },
      {
        condition: person.問卷.停經原因 == "子宮切除",
        text: "V",
        left: 112.8,
        top: 177,
        style: ["font14"],
      },
      {
        condition: person.問卷.停經原因 == "卵巢切除",
        text: "V",
        left: 131.8,
        top: 167,
        style: ["font14"],
      },
      {
        condition: person.問卷.停經原因 == "其他",
        text: "V",
        left: 93.5,
        top: 171.6,
        style: ["font14"],
      },
      {
        condition: person.問卷.生產次數,
        text: person.問卷.生產次數,
        left: 68,
        top: 183.8,
        style: ["font14"],
      },
      {
        condition: person.問卷.曾餵母乳一個月以上 === "是",
        text: "V",
        left: 117.6,
        top: 188,
        style: ["font14"],
      },
      {
        condition: person.問卷.曾餵母乳一個月以上 === "否",
        text: "V",
        left: 127.2,
        top: 188,
        style: ["font14"],
      },
      {
        condition: person.問卷.第一胎生產實足年齡,
        text: person.問卷.第一胎生產實足年齡,
        left: 84,
        top: 193.2,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用口服避孕藥 === "是",
        text: "V",
        left: 84.2,
        top: 205,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用口服避孕藥 === "否",
        text: "V",
        left: 147.7,
        top: 205,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用口服避孕藥 === "是",
        text: person.問卷.幾歲開始口服避孕藥,
        left: 97.5,
        top: 205,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用口服避孕藥 === "是",
        text: person.問卷.服用口服避孕藥年限,
        left: 131.5,
        top: 205,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用賀爾蒙 === "是",
        text: "V",
        left: 84.2,
        top: 200,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用賀爾蒙 === "否",
        text: "V",
        left: 147.7,
        top: 200,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用賀爾蒙 === "是",
        text: person.問卷.開始服用賀爾蒙年齡,
        left: 97.5,
        top: 200,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否服用賀爾蒙 === "是",
        text: person.問卷.服用賀爾蒙年限,
        left: 131.5,
        top: 200,
        style: ["font14"],
      },
      {
        condition: person.問卷.醫療人員乳房觸診,
        text: "V",
        left: 52.2,
        top: 234,
        style: ["font14"],
      },
      {
        condition: person.問卷.乳房超音波檢查,
        text: "V",
        left: 77.7,
        top: 234,
        style: ["font14"],
      },
      {
        condition: person.問卷.乳房攝影X光檢查,
        text: "V",
        left: 110.3,
        top: 234,
        style: ["font14"],
      },
      {
        condition:
          !person.問卷.乳房攝影X光檢查 &&
          !person.問卷.乳房超音波檢查 &&
          !person.問卷.醫療人員乳房觸診,
        text: "V",
        left: 139,
        top: 234,
        style: ["font14"],
      },
    ],
  };
};
module.exports.乳攝2 = (person, section) => {
  ({ person, section } = normalizePrintPayload(person, section));
  return {
    bg: "乳攝_2.jpg",
    items: [],
  };
};
module.exports.子抹 = (person, section) => {
  ({ person, section } = normalizePrintPayload(person, section));
  return {
    bg: "子抹.jpg",
    items: [
      {
        condition: true,
        text: "⬤",
        left: 32.2,
        top: 22,
        style: ["font14"],
      },
      {
        condition: section.抹片車及設站篩檢 == "否",
        text: "⬤",
        left: 62,
        top: 27,
        style: ["font14"],
      },
      {
        condition: section.抹片車及設站篩檢 == "抹片車",
        text: "⬤",
        left: 71,
        top: 27,
        style: ["font14"],
      },
      {
        condition: section.抹片車及設站篩檢 == "設站篩檢",
        text: "⬤",
        left: 87.5,
        top: 27,
        style: ["font14"],
      },
      {
        condition: true,
        text: person.姓名,
        left: 43.1,
        top: 61,
        style: ["font15"],
      },
      {
        condition: true,
        text: person.出生年月日,
        left: 43,
        top: 66.5,
        width: 50,
        pl: 2,
        style: ["font15", "bg"],
        textAlign: "left",
      },
      {
        condition: true,
        text: person.身分證字號,
        left: 24,
        top: 76,
        width: 55,
        pl: 2,
        style: ["font15", "bg"],
      },
      {
        condition: true,
        text: person.電話,
        left: 35,
        top: 81,
        width: 60,
        pl: 3,
        style: ["font15", "bg"],
        textAlign: "left",
      },
      {
        condition: person.問卷.教育程度 == "無",
        text: "⬤",
        left: 34.8,
        top: 86,
        style: ["font14"],
      },
      {
        condition: person.問卷.教育程度 == "小學",
        text: "⬤",
        left: 44,
        top: 86,
        style: ["font14"],
      },
      {
        condition: person.問卷.教育程度 == "國(初)中",
        text: "⬤",
        left: 57,
        top: 86,
        style: ["font14"],
      },
      {
        condition: person.問卷.教育程度 == "高中/高職",
        text: "⬤",
        left: 76.2,
        top: 86,
        style: ["font14"],
      },
      {
        condition: person.問卷.教育程度 == "專科、大學",
        text: "⬤",
        left: 34.7,
        top: 91,
        style: ["font14"],
      },
      {
        condition: person.問卷.教育程度 == "研究所以上",
        text: "⬤",
        left: 58.9,
        top: 91,
        style: ["font14"],
      },
      {
        condition: person.問卷.教育程度 == "拒答",
        text: "⬤",
        left: 83,
        top: 91,
        style: ["font14"],
      },
      {
        condition: true,
        text: `${區碼[city.name][person.行政區] || ""}`,
        left: 10.5,
        top: 109,
        height: 8.2,
        width: 96,
        pt: 2,
        pl: 70,
        style: ["bg", "font14"],
      },
      {
        condition: true,
        text: person.地址,
        left: 17.5,
        top: 100.5,
        height: 10,
        width: 96,
        pt: 2,
        pl: 2,
        style: ["bg", "font14"],
      },
      {
        condition: true,
        text: city.name,
        left: 44,
        top: 125,
        style: ["font14"],
      },
      {
        condition: true,
        text: person.行政區.replace(city.name, "").replace("區", ""),
        left: 61,
        top: 125,
        style: ["font14"],
      },
      {
        condition: true,
        text: 區碼[city.name]?.[person.行政區] || "",
        left: 86,
        top: 125,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否已經停經 == "是",
        text: "⬤",
        left: 64,
        top: 150,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否已經停經 == "否",
        text: "⬤",
        left: 73.3,
        top: 150,
        style: ["font14"],
      },
      {
        condition: person.問卷.是否已經停經 == "不知道",
        text: "⬤",
        left: 82.8,
        top: 150,
        style: ["font14"],
      },
      {
        condition: true,
        text: person.問卷.最後一次月經日期 || "sss",
        left: 57.8,
        top: 154.6,
        width: 35,
        height: 5.8,
        pl: 4,
        style: ["bg"],
        textAlign: "left",
      },
      {
        condition: person.目前狀態.我目前懷孕中,
        text: "⬤",
        left: 50.8,
        top: 160.2,
        style: ["font14"],
      },
      {
        condition: !person.目前狀態.我目前懷孕中,
        text: "⬤",
        left: 60.1,
        top: 160.2,
        style: ["font14"],
      },
      {
        condition: person.問卷.子宮是否切除 == "是",
        text: "⬤",
        left: 50.8,
        top: 165.2,
        style: ["font14"],
      },
      {
        condition: person.問卷.子宮是否切除 == "否",
        text: "⬤",
        left: 60.1,
        top: 165.2,
        style: ["font14"],
      },
      {
        condition: person.問卷.子宮是否切除 == "不知道",
        text: "⬤",
        left: 69.4,
        top: 165.2,
        style: ["font14"],
      },
      {
        condition: person.問卷.子宮是否受過放射治療 == "是",
        text: "⬤",
        left: 71,
        top: 169.7,
        style: ["font14"],
      },
      {
        condition: person.問卷.子宮是否受過放射治療 == "否",
        text: "⬤",
        left: 80.2,
        top: 169.7,
        style: ["font14"],
      },
      {
        condition: person.問卷.子宮是否受過放射治療 == "不知道",
        text: "⬤",
        left: 89.5,
        top: 169.7,
        style: ["font14"],
      },
      {
        condition: person.問卷.接種過乳突病毒疫苗 == "是",
        text: "⬤",
        left: 42,
        top: 180,
        style: ["font14"],
      },
      {
        condition: person.問卷.接種過乳突病毒疫苗 == "否",
        text: "⬤",
        left: 77.2,
        top: 180,
        style: ["font14"],
      },
      // {
      //   condition: person.問卷.做過乳突病毒檢測 == "是",
      //   text: "⬤",
      //   left: 22.9,
      //   top: 185.5,
      // },
      // {
      //   condition: person.問卷.做過乳突病毒檢測 == "否",
      //   text: "⬤",
      //   left: 32.3,
      //   top: 185.6,
      // },
      // {
      //   condition: person.問卷.非月經異常分泌物 == "是",
      //   text: "⬤",
      //   left: 19.2,
      //   top: 197.4,
      // },
      // {
      //   condition: person.問卷.非月經異常分泌物 == "否",
      //   text: "⬤",
      //   left: 27.4,
      //   top: 197.4,
      // },
      // {
      //   condition: person.問卷.非月經異常分泌物 == "不知道",
      //   text: "⬤",
      //   left: 35.2,
      //   top: 197.4,
      // },
      {
        condition: true,
        text: section.日期.split("-")[0] - 1911,
        left: 64,
        top: 226,
        style: ["font12"],
      },
      {
        condition: true,
        text: section.日期.split("-")[1],
        left: 75,
        top: 226,
        style: ["font12"],
      },
      {
        condition: true,
        text: section.日期.split("-")[2],
        left: 85.5,
        top: 226,
        style: ["font12"],
      },
      {
        condition: true,
        text: section.抹片檢體取樣機構代碼 || "",
        left: 70,
        top: 235.7,
        style: ["font14"],
      },
      {
        condition: section.抹片檢體採檢人員 == "婦產科醫師",
        text: "⬤",
        left: 21.3,
      },
      {
        condition: section.抹片檢體採檢人員 == "家醫科醫師",
        text: "⬤",
        left: 45,
        top: 256,
        style: ["font14"],
      },
      {
        condition:
          section.抹片檢體採檢人員 == "助產士" ||
          section.抹片檢體採檢人員 == "助產人員",
        text: "⬤",
        left: 68,
        top: 256,
        style: ["font14"],
      },
      {
        condition: section.抹片檢體採檢人員 == "公衛護士",
        text: "⬤",
        left: 87,
        top: 256,
        style: ["font14"],
      },
      {
        condition: section.抹片檢體採檢人員 == "衛生所醫師",
        text: "⬤",
        left: 37.3,
        top: 260.9,
        style: ["font14"],
      },
      {
        condition: section.做抹片目的 == "篩檢",
        text: "⬤",
        left: 43.6,
        top: 272,
        style: ["font14"],
      },
      {
        condition: section.做抹片目的 == "懷疑癌症",
        text: "⬤",
        left: 58,
        top: 272,
        style: ["font14"],
      },
      {
        condition: section.做抹片目的 == "追蹤",
        text: "⬤",
        left: 79.1,
        top: 272,
        style: ["font14"],
      },
      {
        condition: section.做抹片目的 == "前次抹片難以判讀",
        text: "⬤",
        left: 44,
        top: 276.2,
        style: ["font14"],
      },
      {
        condition: section.做抹片目的 == "其他",
        text: "⬤",
        left: 79,
        top: 276.2,
        style: ["font14"],
      },
    ],
  };
};
module.exports.口篩 = (person, section) => {
  ({ person, section } = normalizePrintPayload(person, section));
  return {
    bg: "口篩.jpg",
    items: [
      {
        condition: section.口腔支付方式 == "預防保健",
        text: "V",
        left: 27,
        top: 21,
        style: ["font18"],
      },
      {
        condition: section.口腔支付方式 == "健保醫療給付",
        text: "V",
        left: 56,
        top: 21,
        style: ["font18"],
      },
      {
        condition: section.口腔支付方式 == "其他公務預算補助",
        text: "V",
        left: 94,
        top: 21,
        style: ["font18"],
      },
      {
        condition: section.口腔支付方式 == "自費健康檢查",
        text: "V",
        left: 43.7,
        top: 26.1,
        style: ["font18"],
      },
      {
        condition: section.口腔支付方式 == "其他",
        text: "V",
        left: 81.4,
        top: 26.1,
        style: ["font18"],
      },
      {
        condition: section.口腔篩選地點 == "社區或職場設站篩檢",
        text: "V",
        left: 25.4,
        top: 31.5,
        style: ["font18"],
      },
      {
        condition: section.口腔篩選地點 == "醫療院所",
        text: "V",
        left: 74,
        top: 31.5,
        style: ["font18"],
      },
      {
        condition: section.口腔檢查醫師科別 == "牙科",
        text: "V",
        left: 35.4,
        top: 37,
        style: ["font18"],
      },
      {
        condition: section.口腔檢查醫師科別 == "耳鼻喉科",
        text: "V",
        left: 56.1,
        top: 37,
        style: ["font18"],
      },
      {
        condition: section.口腔檢查醫師科別 == "經健康署核可之其他科別專科醫師",
        text: "V",
        left: 85.3,
        top: 37,
        style: ["font18"],
      },
      {
        condition: person.原住民,
        text: "V",
        left: 76.4,
        top: 48,
        style: ["font18"],
      },
      {
        condition: !person.原住民,
        text: "V",
        left: 89.1,
        top: 48,
        style: ["font18"],
      },
      {
        condition: 性別(person) == "男",
        text: "V",
        left: 75.8,
        top: 53.6,
        style: ["font18"],
      },
      {
        condition: 性別(person) == "女",
        text: "V",
        left: 90.7,
        top: 53.6,
        style: ["font18"],
      },
      {
        condition: true,
        text: person.姓名,
        left: 30.7,
        top: 53.6,
      },
      {
        condition: true,
        text: person.出生年月日,
        left: 29,
        top: 59.5,
        width: 60,
        pl: 2,
        style: ["bg"],
      },
      {
        condition: true,
        text: person.身分證字號,
        left: 39,
        top: 69.5,
        width: 60,
        pl: 2,
        style: ["bg"],
      },
      {
        condition: true,
        text: person.電話,
        left: 30.7,
        top: 80.4,
      },
      {
        condition: true,
        text: 區碼[city.name][person.行政區] || "",
        left: 59.7,
        top: 86.9,
        width: 30,
        pl: 2,
        style: ["bg"],
      },
      {
        condition: true,
        text: person.地址,
        left: 10,
        top: 93,
        width: 90,
        height: 13,
        pt: 1,
        style: ["bg", "font14"],
      },
      {
        condition: person.問卷.教育程度 == "無",
        text: "V",
        left: 18.2,
        top: 105.2,
        style: ["font18"],
      },
      {
        condition: person.問卷.教育程度 == "小學",
        text: "V",
        left: 34.3,
        top: 105.2,
        style: ["font18"],
      },
      {
        condition: person.問卷.教育程度 == "國(初)中",
        text: "V",
        left: 54.9,
        top: 105.2,
        style: ["font18"],
      },
      {
        condition: person.問卷.教育程度 == "高中/高職",
        text: "V",
        left: 83.8,
        top: 105.2,
        style: ["font18"],
      },
      {
        condition: person.問卷.教育程度 == "專科、大學",
        text: "V",
        left: 18.4,
        top: 109.9,
        style: ["font18"],
      },
      {
        condition: person.問卷.教育程度 == "研究所以上",
        text: "V",
        left: 51.4,
        top: 109.9,
        style: ["font18"],
      },
      {
        condition: person.問卷.教育程度 == "拒答",
        text: "V",
        left: 84.4,
        top: 109.9,
        style: ["font18"],
      },
      {
        condition:
          !person.目前狀態.我目前有嚼食檳榔的習慣 &&
          !person.目前狀態.我過去曾經有嚼食檳榔的習慣,
        text: "V",
        left: 5.6,
        top: 124,
        style: ["font18"],
      },
      {
        condition:
          !person.目前狀態.我目前有嚼食檳榔的習慣 &&
          person.目前狀態.我過去曾經有嚼食檳榔的習慣,
        text: "V",
        left: 5.6,
        top: 128,
        style: ["font18"],
      },
      {
        condition:
          person.問卷.檳榔年資 == "少於10年" &&
          person.問卷.每日檳榔量 == "少於20顆",
        text: "V",
        left: 5.6,
        top: 132.4,
        style: ["font18"],
      },
      {
        condition:
          person.問卷.檳榔年資 == "少於10年" &&
          person.問卷.每日檳榔量 == "20顆以上",
        text: "V",
        left: 5.6,
        top: 136.6,
        style: ["font18"],
      },
      {
        condition:
          person.問卷.檳榔年資 == "10年以上" &&
          person.問卷.每日檳榔量 == "少於20顆",
        text: "V",
        left: 5.6,
        top: 140.8,
        style: ["font18"],
      },
      {
        condition:
          person.問卷.檳榔年資 == "10年以上" &&
          person.問卷.每日檳榔量 == "20顆以上",
        text: "V",
        left: 5.6,
        top: 145,
        style: ["font18"],
      },

      {
        condition:
          !person.目前狀態.我目前有吸菸的習慣 &&
          !person.目前狀態.我過去曾經有吸菸的習慣,
        text: "V",
        left: 5.6,
        top: 153.8,
        style: ["font18"],
      },
      {
        condition:
          !person.目前狀態.我目前有吸菸的習慣 &&
          person.目前狀態.我過去曾經有吸菸的習慣,
        text: "V",
        left: 5.6,
        top: 158,
        style: ["font18"],
      },
      {
        condition:
          person.問卷.吸菸年資 == "少於10年" &&
          person.問卷.每天吸菸量 == "少於20支",
        text: "V",
        left: 5.6,
        top: 162.3,
        style: ["font18"],
      },
      {
        condition:
          person.問卷.吸菸年資 == "少於10年" &&
          person.問卷.每天吸菸量 == "20支以上",
        text: "V",
        left: 5.6,
        top: 166,
        style: ["font18"],
      },
      {
        condition:
          person.問卷.吸菸年資 == "10年以上" &&
          person.問卷.每天吸菸量 == "少於20支",
        text: "V",
        left: 5.6,
        top: 170,
        style: ["font18"],
      },
      {
        condition:
          person.問卷.吸菸年資 == "10年以上" &&
          person.問卷.每天吸菸量 == "20支以上",
        text: "V",
        left: 5.6,
        top: 174.5,
        style: ["font18"],
      },
      {
        condition: person.問卷.口腔自覺異狀,
        text: "V",
        left: 89.5,
        top: 190,
        style: ["font18"],
      },
      {
        condition: !person.問卷.口腔自覺異狀,
        text: "V",
        left: 73,
        top: 190,
        style: ["font18"],
      },
      {
        condition: true,
        text: section.口腔初檢醫療院所代碼,
        left: 65,
        top: 222.3,
      },
      {
        condition: true,
        text: section.日期.split("-")[0] - 1911,
        left: 40.5,
        top: 227.3,
      },
      {
        condition: true,
        text: section.日期.split("-")[1],
        left: 57,
        top: 227.3,
      },
      {
        condition: true,
        text: section.日期.split("-")[2],
        left: 72,
        top: 227.3,
      },
    ],
  };
};

module.exports.問卷封面 = (person, section) => {
  ({ person, section } = normalizePrintPayload(person, section));
  return {
    bg: "問卷封面.jpg",
    items: [
      {
        condition: true,
        text: city.name + "政府衛生局",
        left: 51,
        top: 15,
        pl: 10,
        width: 100,
        style: ["font26", "bold", "bg"],
      },
      {
        condition: true,
        text: city.name + "政府衛生局",
        left: 55,
        top: 60,
        pl: 2,
        width: 42,
        style: ["font18", "bolder", "bg"],
      },
      {
        condition: true,
        text: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
        left: 18,
        top: 80.2,
        pl: 1,
        mb: 0,
        width: 37,
        height: 6.6,
        style: ["font16", "bg"],
      },
      {
        condition: true,
        text: city.name + "健康共照雲",
        left: 18,
        top: 81,
        pl: 1,
        mb: 0,
        width: 38,
        height: 10,
        style: ["font17", "bolder"],
      },

      {
        condition: true,
        text: person.姓名,
        left: 40,
        top: 36.5,
        style: ["font20", "bold"],
      },
      {
        condition: true,
        text: 年齡(person),
        left: 115,
        top: 36.5,
        style: ["font20", "bold"],
      },
      {
        condition: 性別(person) == "男",
        text: "V",
        left: 173.3,
        top: 37,
        style: ["font22", "bold"],
      },
      {
        condition: 性別(person) == "女",
        text: "V",
        left: 186,
        top: 37,
        style: ["font22", "bold"],
      },
      {
        condition: !!person.report[0].外部問卷,
        text: "V",
        left: 77,
        top: 111.5,
        style: ["bold"],
      },
      {
        condition: !person.report[0].外部問卷,
        text: "V",
        left: 100.5,
        top: 111.5,
        style: ["bold"],
      },
    ],
  };
};
module.exports.BC肝 = (person, section) => {
  ({ person, section } = normalizePrintPayload(person, section));
  return {
    bg: "BC肝.jpg",
    items: [
      {
        condition: true,
        text: person.身分證字號,
        left: 74,
        top: 102.5,
        style: ["font16", "bold"],
      },
      {
        condition: true,
        text: person.姓名,
        left: 133,
        top: 102.5,
        style: ["font16", "bold"],
      },
      {
        condition: true,
        text: 性別(person),
        left: 177,
        top: 102.5,
        style: ["font16", "bold"],
      },
      {
        condition: true,
        text: `民國 ${person.出生年月日}（${年齡(person)}歲）`,
        left: 77,
        top: 116,
        style: ["font16", "bold"],
      },
      {
        condition: true,
        text: person.電話,
        left: 147,
        top: 116,
        style: ["font16", "bold"],
      },
      {
        condition: true,
        text: person.地址,
        left: 60,
        top: 132,
        style: ["font16", "bold"],
      },
      {
        condition: true,
        text: city.name,
        left: 66,
        top: 150,
        style: ["font16", "bold"],
      },
      {
        condition: person.問卷.教育程度 == "無",
        text: "V",
        left: 126.3,
        top: 148.5,
      },
      {
        condition: person.問卷.教育程度 == "小學",
        text: "V",
        left: 138,
        top: 148.5,
      },
      {
        condition: person.問卷.教育程度 == "國(初)中",
        text: "V",
        left: 153.5,
        top: 148.5,
      },
      {
        condition: person.問卷.教育程度 == "高中/高職",
        text: "V",
        left: 176.4,
        top: 148.5,
      },
      {
        condition: person.問卷.教育程度 == "專科、大學",
        text: "V",
        left: 126.3,
        top: 153.5,
      },
      {
        condition: person.問卷.教育程度 == "研究所以上",
        text: "V",
        left: 153.5,
        top: 153.5,
      },
      {
        condition: person.問卷.個人高血壓,
        text: "V",
        left: 38.8,
        top: 164.7,
      },
      {
        condition: person.問卷.個人糖尿病,
        text: "V",
        left: 64.2,
        top: 164.7,
      },
      {
        condition: person.問卷.個人高血脂症,
        text: "V",
        left: 91.8,
        top: 164.7,
      },
      {
        condition: person.問卷.個人心臟病,
        text: "V",
        left: 123.5,
        top: 164.7,
      },
      {
        condition: person.問卷.個人腦中風,
        text: "V",
        left: 151,
        top: 164.7,
      },
      {
        condition: person.問卷.個人腎臟病,
        text: "V",
        left: 176.5,
        top: 164.7,
      },
      {
        condition: person.問卷.個人B型肝炎,
        text: "V",
        left: 38.8,
        top: 170.1,
      },
      {
        condition: person.問卷.個人C型肝炎,
        text: "V",
        left: 65.3,
        top: 170.1,
      },
      {
        condition: person.問卷.個人其他精神疾病,
        text: "V",
        left: 94.2,
        top: 170.1,
      },
      {
        condition: person.問卷.個人其他疾病,
        text: "V",
        left: 126,
        top: 170.1,
      },
    ],
  };
};

function 性別(person) {
  const 身分證字號 = (person && person.身分證字號) || "";
  switch (身分證字號[1]) {
    case "1":
    case "A":
    case "C":
      return "男";
      break;
    case "2":
    case "B":
    case "D":
      return "女";
      break;
  }
}

function 年齡(person) {
  if (!person || !person.出生年月日) return "";
  let birth = parseInt(person.出生年月日) + 19110000 + "";
  if (!dayjs(birth).isValid()) return "";
  return dayjs().year() - dayjs(birth).year();
}

function 民國年(date) {
  return parseInt(date) - 19110000;
}
